import { AmazonApiTypes } from 'pages/users/amazon/amazon.interface';

/**
 * Amazon SP and Amazon Ads service have very similar endpoints
 */
export const getAmazonTypeUrl = (type = AmazonApiTypes.SP) => {
  return type === AmazonApiTypes.SP ? 'amazon' : 'ads';
};
